import React from 'react';
import ClassAssembly  from 'views/ClassAssembly7A';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;